import {
  GridRenderEditCellParams,
  GridValueFormatterParams,
  GridPreProcessEditCellProps,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import { dayjs, dayParseUTCFormat } from 'utils/DateUtils';

import { GridEditDateCell } from 'components/DatatableComponent/CustomDateTimeInput';
import { ENV_CONFIG } from 'config/env';

// Date Time

export function RulesInputDateTime(renderFormat: string = ENV_CONFIG.config.DATE_TIME_FORMAT) {
  return {
    type: 'dateTime',
    width: 230,

    renderEditCell: (params: GridRenderEditCellParams) => {
      return (
        <GridEditDateCell
          {...params}
          // @ts-ignore
          colDef={{
            type: 'dateTime',
          }}
        />
      );
    },

    valueFormatter: (params: GridValueFormatterParams) => {
      if (typeof params.value === 'string') {
        return dayParseUTCFormat(params.value, renderFormat);
      }
      return '';
    },
  };
}

export function RuleDateTimeAddition(
  column: string,
  type: string,
  number: number,
  renderFormat: string = ENV_CONFIG.config.DATE_TIME_FORMAT
) {
  return {
    type: 'dateTime',
    width: 230,
    editable: false,
    renderEditCell: (params: GridRenderEditCellParams) => {
      return (
        <GridEditDateCell
          {...params}
          // @ts-ignore
          colDef={{
            type: 'dateTime',
          }}
        />
      );
    },
    valueGetter: (params: GridValueGetterParams) => {
      const referenceValue = params?.row?.[column] || null;
      if (referenceValue) {
        // operate on the UTC instant; display converts to app-zone in valueFormatter
        // @ts-ignore
        return dayjs.utc(referenceValue).add(number, type);
      }

      return null;
    },
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const value = params?.otherFieldsProps?.[column].value || '';
      const date = dayjs(value);
      // @ts-ignore
      return { ...params.props, value: date.add(number, type) };
    },
    valueFormatter: (params: GridValueFormatterParams) => {
      if (!params.value) return '';
      const iso = dayjs.isDayjs(params.value) ? params.value.toISOString() : params.value;
      return dayParseUTCFormat(iso, renderFormat);
    },
  };
}
